import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = [{
  title: 'Quieres crear algo con tus manos',
  desc: 'Buscas una actividad creativa y relajante para desconectar y disfrutar el proceso.'
}, {
  title: 'Nunca hiciste manualidades',
  desc: 'Empiezas desde cero, sin experiencia previa y sin saber dibujar.'
}, {
  title: 'Quieres regalar algo distinto',
  desc: 'Piezas hechas a mano que valen mucho más que un regalo comprado.'
}, {
  title: 'Piensas en un ingreso extra',
  desc: 'Vender piezas decorativas desde casa, a tu ritmo y con poca inversión.'
}];
export function Benefits() {
  return <section className="bg-deco-beige py-14 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-18" data-mp="3cs4haq3i1nfn">
      <div className="max-w-6xl mx-auto" data-id="element-19" data-mp="3cu7i8566x0z5">
        <p className="text-center text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-20" data-mp="1fzumw10a6dyy">
          Para quién es
        </p>
        <h2 className="text-center font-serif text-2xl sm:text-4xl text-deco-forest font-semibold mb-12" data-id="element-21" data-mp="1ayorfvf8kclq">
          Esta guía es <span className="italic text-deco-brick" data-id="element-22" data-mp="6sjhiaw622ro">para ti</span>{' '}
          si…
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5" data-id="element-23" data-mp="3oyo006qmfdcz">
          {items.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-deco-cream rounded-2xl p-6 border border-deco-aqua/30 flex flex-col" data-id="element-24" data-mp="3tyk5kaeyvcun" data-mpi={i}>
              <span className="w-8 h-8 rounded-full bg-deco-aqua text-white flex items-center justify-center mb-5 shrink-0" style={{
            backgroundColor: "#D98267",
            backgroundImage: "none"
          }} data-id="element-25" data-mp="14gtjipvycqis">
                <Check size={15} strokeWidth={2.5} data-id="element-26" data-mp="1j38p4t21gce7" />
              </span>
              <h3 className="font-serif text-base sm:text-lg text-deco-forest font-semibold leading-snug mb-2" data-id="element-27" data-mp="1j2h3a9y8tt14">
                {item.title}
              </h3>
              <p className="text-[13px] text-deco-forest/60 leading-relaxed" data-id="element-28" data-mp="194b4i17qh30h">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}